import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useConfiguration } from '@travel-frontend/core';
import { IconExitToApp } from '@travel-frontend/icons';
import { noop } from 'lodash';
import { useTranslation } from 'next-i18next';
import { useRef, forwardRef } from 'react';
import { useFocusInside } from 'react-focus-lock';
import { Content } from '../../../../components/AccountControl/components/BurgerMenu/components/index.js';
import { useAuthentication } from '../../../../hooks/index.js';
import { ActionLink, Divider, LabelMedium, Link } from '../../../../primitives/index.js';
export const BurgerMenu = /*#__PURE__*/_styled(forwardRef(({
  onClickItem,
  onLogout = noop,
  ...restProps
}, ref) => {
  const {
    t
  } = useTranslation('accountControl');
  const initialFocusRef = useRef(null);
  const origin = useConfiguration('origin');
  const loginUrl = useConfiguration('loginUrl');
  const portal = useConfiguration('portal');
  const {
    isLoggedIn,
    toggleWidget,
    doLogout
  } = useAuthentication();
  useFocusInside(initialFocusRef);
  const handleLogout = () => {
    doLogout();
    onLogout();
  };
  const shouldDisplayVouchers = portal.startsWith('aidu');
  return _jsx(Content, {
    ref: ref,
    ...restProps,
    isLoggedIn: isLoggedIn,
    children: isLoggedIn ? _jsxs(_Fragment, {
      children: [_jsx(Link, {
        ref: initialFocusRef,
        tabIndex: 0,
        href: `${loginUrl}/travels`,
        color: "contentPrimary",
        size: "large",
        onClick: onClickItem,
        children: t('myTravels')
      }), _jsx(Link, {
        tabIndex: 0,
        href: `${loginUrl}/profile`,
        color: "contentPrimary",
        underline: false,
        size: "large",
        onClick: onClickItem,
        children: t('myProfile')
      }), shouldDisplayVouchers && _jsx(Link, {
        tabIndex: 0,
        href: `${loginUrl}/vouchers`,
        color: "contentPrimary",
        underline: false,
        size: "large",
        onClick: onClickItem,
        children: t('vouchers')
      }), _jsx(Link, {
        tabIndex: 0,
        href: `${origin}/service/faq`,
        color: "contentPrimary",
        underline: false,
        target: "_blank",
        size: "large",
        onClick: onClickItem,
        children: t('contact')
      }), _jsx(Divider, {}), _jsxs(ActionLink, {
        underline: false,
        onClick: event => {
          onClickItem?.(event);
          handleLogout();
        },
        color: "contentPrimary",
        bold: true,
        size: "large",
        children: [t('logout'), _jsx(IconExitToApp, {})]
      })]
    }) :
    // notLoggedInMenu
    _jsxs(_Fragment, {
      children: [_jsx(Link, {
        ref: initialFocusRef,
        tabIndex: 0,
        onClick: event => {
          onClickItem?.(event);
          toggleWidget('signIn');
        },
        size: "large",
        color: "contentPrimary",
        children: t('login')
      }), _jsx(Link, {
        tabIndex: 0,
        onClick: event => {
          onClickItem?.(event);
          toggleWidget('registration');
        },
        size: "large",
        color: "contentPrimary",
        underline: false,
        children: t('register')
      }), _jsx(Link, {
        tabIndex: 0,
        href: `${origin}/service/faq`,
        color: "contentPrimary",
        underline: false,
        target: "_blank",
        size: "large",
        onClick: onClickItem,
        children: _jsxs(LabelMedium, {
          textAlign: "left",
          children: [" ", t('contact')]
        })
      })]
    })
  });
}), process.env.NODE_ENV === "production" ? {
  target: "exid33e0"
} : {
  target: "exid33e0",
  label: "BurgerMenu"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");